import { jsx } from "react/jsx-runtime";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import { validateTidalLicense } from "../../base/index.js";
function AccountTree(props) {
  return /* @__PURE__ */ jsx(
    AccountTreeIcon,
    {
      "data-testid": "AccountTree",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "AccountTree",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
AccountTree.tidalIconMeta = {
  categories: "miscellaneous",
  name: "AccountTree"
};
validateTidalLicense();
export {
  AccountTree
};
//# sourceMappingURL=AccountTree.js.map
